import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { createTheme, ThemeProvider }, "@mui/material/Stack": Stack, "@mui/material/Card": Card, "@mui/material/AppBar": AppBar, "@mui/material/Toolbar": Toolbar, "@mui/material/Typography": Typography, "@mui/material/Button": Button, "@mui/material/Tabs": Tabs, "@mui/material/Tab": Tab } } });
export default ClientProvider;
